<template>
<app-base-main style="padding-top: 6px;" :contentStyle="{'height': '100%'}">
  <template #base-content>
  <div class="box">
    <div class="layout" v-show="!costSharingShow">
      <div class="tabs-content">
        <span v-for="item in tabs" :key="item.id" :class="[tabsActive === item.id ? 'tabs--color' : 'color888']"
              class="tabs" @click="clickTabs(item.id)">{{ item.text }}</span>
      </div>
      <div style="flex: 1; overflow: auto" class="finance-profit-report">
        <div style="padding-top: 10px; height: 100%; box-sizing: border-box;">
          <component :is="renderComponent" v-loading="loading" @pageBack="pageBack"/>
        </div>
      </div>
    </div>
    <cost-sharing v-if="costSharingShow" @pageBack="costSharingShow=!costSharingShow" :dateValue="dateValue" style="height: 100%;"></cost-sharing>
  </div>
  </template>
</app-base-main>
</template>

<script>
const FinanceProfitReportMonth = () => import("./table/finance-profit-report-month");
const FinanceProfitReportMarket = () => import("./table/finance-profit-report-market");
const FinanceProfitReportCategory = () => import("./table/finance-profit-report-category");
const FinanceProfitReportParentAsin = () => import("./table/finance-profit-report-parentAsin");
const FinanceProfitReportAsin = () => import("./table/finance-profit-report-asin");
const FinanceProfitReportSku = () => import("./table/finance-profit-report-sku");
const FinanceProfitReportMsku = () => import("./table/finance-profit-report-msku");
const FinanceProfitReportSettlement = () => import("./table/finance-profit-report-settlement");

import costSharing from './cost-sharing'

const TAB_CACHE_KEY = `FINANCE_PROFIT_REPORT_TABS`
export default {
  name: "finance-profit-report",
  components: {
    costSharing
  },
  data() {
    return {
      costSharingShow: false,
      dateValue:null,
      filter: {},
      tabs: [
        {id: 'msku', text: 'MSKU', component: FinanceProfitReportMsku},
        {id: 'asin', text: 'ASIN', component: FinanceProfitReportAsin},
        {id: 'parentAsin', text: '父ASIN', component: FinanceProfitReportParentAsin},
        {id: 'sku', text: 'SKU', component: FinanceProfitReportSku},
        {id: 'category', text: '品类', component: FinanceProfitReportCategory},
        {id: 'market', text: '店铺', component: FinanceProfitReportMarket},
        {id: 'month', text: '按月度', component: FinanceProfitReportMonth},
        {id: 'settlement', text: '结算明细', component: FinanceProfitReportSettlement},
      ],
      loading: false,
      renderComponent: FinanceProfitReportMsku,
      tabsActive: 'msku',
      isnotStorageg: true
    }
  },

  provide() {
    return {
      getFilter: () => this.filter,
      setFilter: this.setFilter
    }
  },
  created() {
    this.getRemoteCacheTab()
  },
  beforeDestroy() {
    this.$cache.setCache(TAB_CACHE_KEY, {tabsActive: this.tabsActive})
  },
  methods: {
    pageBack(val){
      this.dateValue=val;
      this.costSharingShow=!this.costSharingShow;
    },
    setFilter(filter) {
      this.filter = filter
    },
    clickTabs(key) {
      this.tabsActive = key;
      this.loading = true
      setTimeout(() => {
        this.renderComponent = this.tabs.find(v => v.id === this.tabsActive).component
        this.$nextTick(() => {
          this.loading = false
        })
      }, 300)
    },
    async getRemoteCacheTab() {

      const tabCache = await this.$cache.getCache(TAB_CACHE_KEY)
      if (tabCache && tabCache.params) {
        try {
          const {tabsActive} = JSON.parse(tabCache.params)
          this.tabsActive = tabsActive
          this.renderComponent = this.tabs.find(v => v.id === this.tabsActive).component
        } catch (e) {
          console.warn(e)
        }

      } else {
        this.tabsActive = 'msku'
      }
    }
  },

}
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #ffffff;
  /* padding: 0 10px; */
  /* box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15); */
}

.tabs-content {
  border-bottom: 1px solid #e8e8e8;
  width: 100%;
}

.tabs {
  display: inline-block;
  width: auto;
  margin-right: 32px;
  text-align: center;
  margin-top: 6px;
  padding-bottom: 4px;
  cursor: pointer;
  font-size: 13px;
}

.tabs--color {
  border-bottom: 2px solid #1F6EEF;
  color: #1F6EEF;
}

.color888 {
  color: #666;
}

/deep/ .table-shadow {
  box-shadow: unset;
}

.finance-profit-report /deep/ .el-table thead.is-group th {
  background: #ffffff;
}

// /deep/.fixed-left--wrapper.vxe-table--body-wrapper  {
//   overflow-x: hidden !important;
// }
.vxe-table--render-default:not(.is--empty).is--footer.is--scroll-x .vxe-table--body-wrapper{
  overflow-x: hidden;
}
/deep/ .gj-table .gj-help--icon .gj-icon{
  color: #999999;
}
/deep/ .vxe-table--render-default.border--full .vxe-table--fixed-left-wrapper .vxe-body--column {
  border-right-color: #f6f7f8;
}
</style>
